import { getDate, getHours, getMinutes, getMonth, getYear } from 'date-fns'
import { saveAs } from 'file-saver'
import { createEvent, EventAttributes } from 'ics'

export const useDownloadCalendrierLien = (
  titre: string,
  description: string,
  date: Date,
  duree: { heures: number, minutes: number }
): () => void => {
  const annee = getYear(date)
  const mois = getMonth(date) + 1
  const jour = getDate(date)
  const heure = getHours(date)
  const minutes = getMinutes(date)
  const event: EventAttributes = {
    title: titre,
    description,
    start: [annee, mois, jour, heure, minutes],
    duration: { hours: duree.heures, minutes: duree.minutes }
  }
  return () => createEvent(event, (_, value) => {
    const blob = new Blob([value], { type: 'text/plain;charset=utf-8' })
    saveAs(blob, `${ titre }.ics`)
  })
}
